/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { map } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class SoftCloseService {
  private url: string = environment.host;
  private volCheckURL: string = environment.host + '/commissionrun/volumecheck';
  private companyUrl: string = environment.host + '/company/';
  private payUrl: string = environment.host + '/download/extract/';
  private advancePaymentUrl: string = environment.host + '/advancePayment';
  private planurl: string = environment.host + '/plan';
  private metricModalTriggerSubject = new Subject<any>();
  public metricModalTrigger$ = this.metricModalTriggerSubject.asObservable();

  constructor(private http: HttpClient) {}

  public getAllTitlesTabType(planId: any) {
    const titleurl = this.planurl.toString() + '/' + planId + '/title?tabType=' + 'titlesview/comissionprocessing';
    return this.http.get(titleurl).toPromise();
  }

  public softClose(periodName: any, regCode?: string) {
    if (regCode) {
      return this.http
        .put(this.url.toString() + '/periodclose/' + periodName + '?regionCode=' + regCode, null)
        .toPromise();
    } else {
      return this.http.put(this.url.toString() + '/periodclose/' + periodName, null).toPromise();
    }
  }

  // subPeriod close
  public subPeriodClose(periodName: any, regCode?: string) {
    if (regCode) {
      return this.http
        .put(this.url.toString() + '/subperiodclose/' + periodName + '?regionCode=' + regCode, null)
        .toPromise();
    } else {
      return this.http.put(this.url.toString() + '/subperiodclose/' + periodName, null).toPromise();
    }
  }

//   payFileGenerate(currentPeriod, runNumber) {
//     const url = this.payUrl + currentPeriod + '/pay/' + runNumber;
//     return url;
//     //return this.http.get(url, {responseType: 'text'}).toPromise();
//   }

//   payFileExtract(currentPeriod, runNumber) {
//     const url = this.payUrl + currentPeriod + '/extract/' + runNumber;
//     return url;
//     //return this.http.get(url, {responseType: 'text'}).toPromise();
//   }

  public commissionRun(periodName: any, regCode?: string) {
    if (regCode) {
      return this.http
        .put(this.url.toString() + '/commissionrun/' + periodName + '?regionCode=' + regCode, null)
        .toPromise();
    } else {
      return this.http.put(this.url.toString() + '/commissionrun/' + periodName, null).toPromise();
    }
  }

  public getPlanPeriod(regCode: string, companyCode: any) {
    if (companyCode) {
      if (regCode) {
        return this.http
          .get(this.url.toString() + '/period?companyCode=' + companyCode + '&regionCode=' + regCode)
          .toPromise();
      } else {
        return this.http.get(this.url.toString() + '/period?companyCode=' + companyCode).toPromise();
      }
    } else {
      if (regCode) {
        return this.http.get(this.url.toString() + '/period?regionCode=' + regCode).toPromise();
      } else {
        return this.http.get(this.url.toString() + '/period').toPromise();
      }
    }
  }

  public getPlanPeriodByName(periodName: any, regCode?: string) {
    if (regCode) {
      return this.http.get(this.url.toString() + '/period/' + periodName + '?regionCode=' + regCode).toPromise();
    } else {
      return this.http.get(this.url.toString() + '/period/' + periodName).toPromise();
    }
  }

  public getPeriodStatus() {
    return this.http.get(this.url.toString() + '/periodstatus').toPromise();
  }

  public updatePeriodStatus(periodObj: any) {
    return this.http.put(this.url.toString() + '/update/periodstatus', periodObj).toPromise();
  }

  public getCommisionRunDetails(periodName: any, reg: any) {
    if (reg) {
      return this.http
        .get(this.url.toString() + '/commissionrundetails/' + periodName + '?regionCode=' + reg)
        .toPromise();
    } else {
      return this.http.get(this.url.toString() + '/commissionrundetails/' + periodName).toPromise();
    }
  }

  public getCompanyGenConfiguration(companyId: any) {
    return this.http.get(this.companyUrl.toString() + companyId + '/configuration').toPromise();
  }

  public reProcess(periodName: any) {
    return this.http.put(this.url.toString() + '/reprocess/' + periodName, null).toPromise();
  }

  public getGlobalVolumeDefinitions() {
    const plan = this.url + '/volume-definitions';
    return this.http.get(plan).toPromise();
  }

  public getVolConfigDetails() {
    return this.http.get(this.volCheckURL.toString()).toPromise();
  }

  public updateVolConfigDetails(payloadObj: any) {
    return this.http.post(this.volCheckURL.toString(), payloadObj).toPromise();
  }

  public generateBonusStatement(currentPeriod: any, companyCode: any) {
    let url = this.url + '/bonus/' + currentPeriod;
    if (companyCode) {
      url = url + '?companyCode=' + companyCode;
    }
    return this.http.get(url).toPromise();
  }

  public emailBonusStatement(currentPeriod: any, companyCode: any) {
    let url = this.url + '/bonus/' + currentPeriod + '?emailFlag=true';
    if (companyCode) {
      url = url + '&companyCode=' + companyCode;
    }
    return this.http.get(url).toPromise();
  }
 
  public downloadBonusStatement(currentPeriod: any) {
    const url = this.url + '/download/bonus/' + currentPeriod;
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/pdf, application/json');
    return  this.http.get(url, { headers: headers , responseType : 'blob'  }).pipe(
      map((res:Blob) => { 
        const blob = new Blob([res]);
          return new Blob([blob], { type: 'application/pdf' });
      })
    );
  }

  public paymentRun(currentPeriod: any, regionCode: string) {
    if (regionCode) {
      const url = this.url + '/commissionrun/' + currentPeriod + '?pass=2&regionCode=' + regionCode;
      return this.http.put(url, {}).toPromise();
    } else {
      const url = this.url + '/commissionrun/' + currentPeriod + '?pass=2';
      return this.http.put(url, {}).toPromise();
    }
  }

  public finalBook(periodObj: any) {
    const url = this.url + '/finalBook';
    return this.http.put(url, periodObj).toPromise();
  }

  public getRegions() {
    const url = environment.host + '/company?tabType=' + 'CP';
    return this.http.get(url.toString()).toPromise();
  }

  public periodHighJob(periodName: any) {
    const url = this.url + '/periodhighjob/' + periodName;
    return this.http.put(url, {}).toPromise();
  }

  public epRetroActiveRun(periodName: any) {
    const url = this.url + '/epretroactive/' + periodName;
    return this.http.put(url, {}).toPromise();
  }

  public getAllRecords(planId: any) {
    const rateCardUrl = this.url.toString() + '/compensation/ratecard/' + planId;
    return this.http.get(rateCardUrl).toPromise();
  }

  public getAllRecordsTabType(planId: any) {
    const rateCardUrl = this.url.toString() + '/compensation/ratecard/' + planId + '?tabType=' + 'CompensationRatecardview/comissionprocessing';
    return this.http.get(rateCardUrl).toPromise();
  }

  public saveAdvancePaymentData(payloadObj: any) {
    return this.http.post(this.advancePaymentUrl.toString(), payloadObj).toPromise();
  }

  public generateSendAmigo(periodName: any) {
    const amigoUrl = this.url + '/sendToAmigo/' + periodName;
    return this.http.get(amigoUrl).toPromise();
  }

  public getCommisionMetricDetails(CRHistoryId: number): Observable<any> {
    return this.http
      .get<any>(this.url.toString() + '/commissionmetricdetails/' + CRHistoryId);
  }

  public triggerMetricModal(data: any) {
    this.metricModalTriggerSubject.next(data);
  }
}
